import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { Event } from '../modules/event';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(
    private http: HttpClient
  ) { }

  async getFilter(): Promise<[string[], string[]]> {
    let resp = this.http.get<[string[], string[]]>(environment.apiUrl + '/filter');
    return await firstValueFrom(resp);
  }

  async getTags(filter: string): Promise<string[]> {
    let resp = this.http.get<string[]>(environment.apiUrl + '/tags' + filter);
    return await firstValueFrom(resp);
  }

  async getEvents(filter: string): Promise<Event[]> {
    let resp = this.http.get<Event[]>(environment.apiUrl + '/events' + filter);
    return await firstValueFrom(resp);
  }

}
